<template>
  <div id="time-selector">
    <el-button id="active-button" class="suggested-time-button" v-if="time" type="primary" @click="timeClicked">
      <div class="suggested-time-label">
        {{ label }}
      </div>
      <div class="suggested-time">
        {{ time }}<br/>
        Click to Select
      </div>
    </el-button>
    <el-button id="inactive-button" class="suggested-time-button" v-if="!time" disabled >
      <div class="suggested-time-label">
        {{ label }}
      </div>
      <div class="suggested-time">
        not available
      </div>
    </el-button>
  </div>
</template>

<script>

export default {
  name: "suggestedTime",
  props: [ 'time', 'label' ],
  data() {
    return {

    }
  },
  computed: {

  },
  methods: {
    timeClicked() {
      this.$emit( 'timeSelected', this.time )
    }
  }
}

</script>

<style scoped lang="scss">

#time-selector {
  margin: 8px;
  float: left;
  @media screen and (max-width: 425px) {
    margin: 8px 0;
    width: 100%;
  }
}

#active-button {
  width: 147px;
  @media screen and (max-width: 425px) {
    width: 100%;
  }
}

#inactive-button {
  width: 147px;
  @media screen and (max-width: 425px) {
    width: 100%;
  }
}

.suggested-time-label {
  // width: 150px;
  margin-bottom: 4px;
  text-decoration: underline;
  @media screen and (max-width: 425px) {
    // width: 100%;
  }
}

.suggested-time-button {
  padding: 8px;
  box-shadow: 0px 7px 10px rgba(0, 0, 0, 0.5);

  @media screen and (max-width: 425px) {
    width: 100%;
  }
}

.suggested-time-button + .suggested-time-button {
  margin-left: 0px;
}

</style>